import { ClinicalData } from '@features/components/CaseCard/Blocks/Clinical/ClinicalData';
import { ClinicalDataType, TimeLine } from '@features/components/CaseCard/types';
import { CaseCardWithTimeline } from './CaseCardWithTimeline';
import { BaseCaseCardProps } from './BaseCaseCard';
import { clinicalDataHeight, gapHeight, timelineHeight } from '../../constants';
import { isCaseTrial, isRandomizationScs } from '@/utils/helpers';
import { OrganType } from '@/api/apis/case';

type CaseCardWithClinicalInfoProps = {
  clinical: ClinicalDataType;
  operationTimeline: TimeLine;
} & BaseCaseCardProps;

export const CaseCardWithClinicalInfo = ({
  caseData,
  operationTimeline,
  clinical,
  onClick,
}: CaseCardWithClinicalInfoProps) => {
  const { organType, randomization, trialProgram, questionnaire } = caseData;
  const isOcs = !isRandomizationScs(randomization);
  const isTrial = isCaseTrial(organType, trialProgram, questionnaire);
  const isLungsTrialOcs = organType === OrganType.Lungs && isTrial && isOcs;
  const hasClinicalRecords = !!clinical.pfRatio?.length || !!clinical.lactate?.length;
  const showClinicalRecords = hasClinicalRecords && !isLungsTrialOcs;
  let extraHeight = timelineHeight + gapHeight;
  if (showClinicalRecords) extraHeight += clinicalDataHeight + gapHeight;

  return (
    <CaseCardWithTimeline
      extraHeight={extraHeight}
      caseData={caseData}
      operationTimeline={operationTimeline}
      onClick={onClick}
    >
      {showClinicalRecords && (
        <ClinicalData data={clinical} organType={organType} ocsPt={operationTimeline.ocsPt ?? ''} isScs={!isOcs} />
      )}
    </CaseCardWithTimeline>
  );
};
